import { useUserPermissions } from "@repo/core/hooks/useUserPermissions";
import { CanViewProps } from "./types";

export const CanView = ({ permissions = [], children }: CanViewProps) => {
  const { hasPermission } = useUserPermissions();

  if (permissions?.length && !hasPermission(permissions)) {
    return null;
  }

  return children;
};
